__webpack_require__.p = ".././seamless_pbr/";